import { apiFetch } from '@carouselgg/auth/client'

export interface InviteDetail {
  id: string
  email: string
  role: string
  status: string
  expires_at: string
  organization: {
    name: string
    slug: string
    logo_url: string
    type: string
  }
  team?: {
    id: string
    name: string
    role: string
  }
}

export interface MyInvite {
  id: string
  email: string
  role: string
  token: string
  expires_at: string
  created_at: string
  organization: {
    name: string
    slug: string
    logo_url: string
    type: string
  }
}

export function getInviteByToken(token: string): Promise<InviteDetail> {
  return apiFetch<InviteDetail>(`/invites/${token}`)
}

export function acceptInvite(token: string): Promise<InviteDetail> {
  return apiFetch<InviteDetail>(`/invites/${token}/accept`, { method: 'POST' })
}

export function declineInvite(token: string): Promise<void> {
  return apiFetch(`/invites/${token}/decline`, { method: 'POST' })
}

export function getMyInvites(): Promise<{ invites: MyInvite[] }> {
  return apiFetch<{ invites: MyInvite[] }>('/invites/mine')
}

export interface InviteLinkPublic {
  code: string
  status: 'active' | 'expired' | 'revoked' | 'exhausted'
  org_role: string
  organization: {
    name: string
    slug: string
    logo_url: string
    type: string
  }
  team?: {
    id: string
    name: string
    role: string
  }
}

export function getJoinLink(code: string): Promise<InviteLinkPublic> {
  return apiFetch<InviteLinkPublic>(`/join/${code}`)
}

export function acceptJoinLink(code: string): Promise<InviteLinkPublic> {
  return apiFetch<InviteLinkPublic>(`/join/${code}/accept`, { method: 'POST' })
}
